'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

var implementation = require('./implementation');

module.exports = function getPolyfill() {
  return typeof Object.values === 'function' ? Object.values : implementation;
};